export class Constants {
  public static  RULE_LIST_PAGE_TITLE = 'Rules';
  public static THING = 'things';
  public static THING_SEARCHBOX_TITLE = 'Select a thing';
  public static DROPDOWN_TITLE = 'Dropdown title';
  public static BOOLEAN = 'BOOLEAN';
  public static NUMBER = 'NUMBER';
  public static NAME = 'name';
  public static DATA_TYPE = 'datatype';
  public static ATTR_SEARCHBOX_TITLE = 'Select attribute';
  public static BOTTOM = 'bottom';
  public static TOP = 'top';
  public static EQUALS = '=';
  public static OPENING_BRACE = '(';
  public static CLOSING_BRACE = ')';
  public static EMPTY = '';
  public static URL = '/things?schema-details=true&name';
  public static NULL = 'NULL';
  public static LOGICAL_OR = '|';
  public static  LOGICAL_AND = '&';
  public static  AND = 'AND';
  public static  OR = 'OR';
  public static ATTR_PRE_LABEL = 'attributes';
  public static LOCATION_PRE_LABEL = 'location';
  public static DOT = '.';
  public static COMMA = ',';
  public static STEP_ONE = 'step-one';
  public static PLACEHOLDER_LABEL = '%s';
  public static CHANNEL_TYPE = {
    OUTPUT: 'output',
    INPUT: 'input'
  };
  public static CHANNELS = {
    NUCLEUS: 'nucleus'
  };
  public static MAIL_ACTION = 'send-mail';
  public static MESSAGES = {
    ERROR: {
      REQUIRED: 'Please fill this field'
    }
  };
  public static OPERATORS = [{label: Constants.EQUALS, type: 'all', translation: 'EQUALS'},
    {label: '!=', type: 'all',  translation: 'NOT EQUALS'}, {label: '<', type: Constants.NUMBER, translation: 'SMALLER THAN'},
    {label: '>', type: Constants.NUMBER, translation: 'GREATER THAN'},
    {label: '<=', type: Constants.NUMBER, translation: 'LESS THAN OR EQUALS'},
    {label: '>=', type: Constants.NUMBER, translation: 'GREATER THAN OR EQUALS'}];

}

export enum CompareWith {
  STATIC_VALUE = 0,
  SAME_THING,
  DIFF_THING
}



// WEBPACK FOOTER //
// ./src/app/rules/constants.ts